import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import classNames from "classnames";
import { isEqual } from "@utils/lodash";
import { Loader, Tooltip } from "../../../../components";

class Action extends Component {
	shouldComponentUpdate = ({
		url,
		disabled,
		active,
		displayName,
		description,
		loading,
		count,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(url, lastProps.url) ||
			!isEqual(disabled, lastProps.disabled) ||
			!isEqual(active, lastProps.active) ||
			!isEqual(displayName, lastProps.displayName) ||
			!isEqual(description, lastProps.description) ||
			!isEqual(loading, lastProps.loading) ||
			!isEqual(count, lastProps.count)
		);
	};

	render() {
		const {
			url,
			onClick,
			disabled,
			active,
			displayName,
			description,
			loading,
			count,
			linkComponent: LinkComponent,
			removeCounts,
		} = this.props;

		return (
			<LinkComponent
				to={url}
				className={classNames({ active, disabled, "header-align": removeCounts })}
				onClick={onClick}
			>
				<span>{displayName}</span>
				<If condition={!removeCounts}>
					<Tooltip content={description}>
						<i
							className={classNames("rkf help-icon", {
								"rkf-question-solid": active,
								"rkf-question-o": !active,
							})}
						/>
					</Tooltip>
					<div className="number-container">
						<Choose>
							<When condition={!loading}>
								<span className="number">{count}</span>
							</When>
							<Otherwise>
								<div className="loader-wrapper">
									<Loader
										active={loading}
										size="small"
										spinnerOnly
									/>
								</div>
							</Otherwise>
						</Choose>
					</div>
				</If>
			</LinkComponent>
		);
	}
}

Action.propTypes = {
	removeCounts: PropTypes.bool,
	url: PropTypes.string,
	linkComponent: PropTypes.elementType,
	onClick: PropTypes.func,
	disabled: PropTypes.bool.isRequired,
	active: PropTypes.bool.isRequired,
	displayName: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	loading: PropTypes.bool.isRequired,
	count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Action.defaultProps = {
	url: "",
	linkComponent: Link,
	onClick: () => {},
	count: 0,
	removeCounts: false,
};

export default Action;
